import { HTMLAttributes } from 'react'

import { TypographyProps } from '@/components/base/Typography'
import ImageParagraph from '@/components/sections/ImageParagraph'

import { WPImage, WPLink, WPPageData, WPVideo } from '@/types'

export type VerticalImageParagraphProps = HTMLAttributes<HTMLElement> &
  Partial<{
    paragraph: {
      pretitle: string
      title: string
      title_component: TypographyProps['component']
      paragraph: string
      button: WPLink
    }
    media: {
      poster: WPImage
      video: WPVideo
    }
    alignment: 'left' | 'right'
    vertical: boolean
    theme: WPPageData['acf']['theme']
  }>

const VerticalImageParagraph = ({ ...props }: VerticalImageParagraphProps) => {
  return <ImageParagraph vertical {...props} />
}

export default VerticalImageParagraph
